export default "__VITE_ASSET__BZzDO3xC__"